export const RETURN_CODE = {
  OK: "OK",
  ERROR: "ERROR",
  ACCOUNT_DOES_NOT_EXIST: "ACCOUNT_DOES_NOT_EXIST",
  DUPLICATE_ACCOUNT_ID: "DUPLICATE_ACCOUNT_ID",
  DUPLICATE_USER_ID: "DUPLICATE_USER_ID",
  DUPLICATE_USER_EMAIL: "DUPLICATE_USER_EMAIL",
  DUPLICATE_USER_PHONE: "DUPLICATE_USER_PHONE",
  PAYMENT_ERROR: "PAYMENT_ERROR",
  ACCESS_DENY: "ACCESS_DENY",
  NEW_IP_LOGIN: "NEW_IP_LOGIN", 
  RETRY_CERT_PHONE: "RETRY_CERT_PHONE",
  EXPIRE_CERT_COUNT: "EXPIRE_CERT_COUNT",
  INSUFFICIENT_BALANCE: "INSUFFICIENT_BALANCE",
  SPAM_TEXT: "SPAM_TEXT",
}

